import React from 'react';
import Button from '../button/button.component';
import './input-filter.styles.scss';
import InputField2 from '../input-field/input-field2.component';

interface IProps {
    classNames?: string;
    value: string;
    onFilter: (evt: any) => void;
    onClear: () => void;
}

export default function InputFilter({
    classNames,
    value,
    onFilter,
    onClear,
}: IProps) {
    return (
        <div className={`filter ${classNames || ''}`}>
            <InputField2
                className="filter__input"
                name="filter"
                label="Filter By Course"
                value={value}
                onChange={onFilter}
            />
            <Button
                type="button"
                className="filter__clear-button"
                onClick={onClear}
            >
                X
            </Button>
        </div>
    );
}
